import { useEffect, useState, useRef } from 'react'

export const useIntersectionObserver = (options) => {
  const ref = useRef(null)

  const [isIntersecting, setIsIntersecting] = useState(false)

  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIsIntersecting(entry.isIntersecting)
    }, options)

    if (ref.current) observer.observe(ref.current)

    return () => {
      if (ref.current) observer.unobserve(ref.current)
    }
  }, [options])

  return { ref, isIntersecting }
}
